import axios from 'axios'
const REACT_APP_API_URL = process.env.REACT_APP_API_URL

export const createUser = async ({name, email, password}) => {

  try {
    const url = `${REACT_APP_API_URL}/token-provider`
    const headers = {
      'Authorization': localStorage.getItem('dashboard_access_token'),
      'Content-Type': 'application/json'
    }
    const body = {
      "type": "create_user",
      'name': name,
      "email": email,
      "password": password
    }
    const response = await axios.post(url, {...body}, {headers: headers})
    return response
  } catch (error) {
    const {response} = error
    return response
  }
}


